@if (true) {
<div class="container-fluid">
    <div class="table-header-container">
        <div class="table-heading">
            Mail Template Editor
        </div>
        <button class="btn btn-outline-primary" title="Go Back" (click)="goBack()">
            <i class="fa fa-arrow-left"></i> Back
        </button>
    </div>

    <form #emailEditor="ngForm" [formGroup]="FormemailEditor">
        <div class="page-sub-heading">
            Subject
        </div>
        <div class="card rounded-4 border-0">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-8">
                        <angular-editor [(ngModel)]="textEditorData" formControlName="textEditorData"
                            [config]="config"></angular-editor>
                    </div>
                    <div class="col-sm-4">
                        <select class="form-control" (change)="onStatusSelect($event.target.value)"
                            formControlName="KeyWordRecord">
                            <option value="0">[Not Selected]</option>
                            <option *ngFor="let mDtl of KeywordData " value="{{mDtl.MainDescr}}">{{mDtl.MainDescr}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-sub-heading mt-4">
            Mail Body
        </div>
        <div class="card rounded-4 border-0">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <angular-editor [(ngModel)]="textEditorData2" formControlName="textEditorData2"
                            [config]="config1"></angular-editor>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center mt-3" (click)="SaveData(emailEditor.value)">
            <button class="btn btn-primary submit-btn small " type="submit">
                Submit
            </button>
        </div>
    </form>
</div>



}@else {
<!-- <my-content placeholder="navigation"> -->

<!-- <div class="col-sm-12 " style="border-bottom: 1px solid #ccc;"></div>
<div class="col-sm-12" style="margin-top: 8px; display:none">
    <div class="col-sm-12"
        style="background-color: #eee; border:1px solid #ddd;padding-top:10px; padding-bottom: 10px;">
        <div class="col-sm-12">
            <form #SearchTemplate="ngForm" [formGroup]="FormSearchTemplate">
                <div class="col-sm-1 text-left height-34">Type</div>
                <div class="col-sm-2"><select class="form-control" formControlName="SelectType"
                        (change)="onTypeSelect($event.target.value)">
                        <option value="0">Alert</option>
                        <option value="1">Escalation</option>
                        <option value="2">Notification</option>
                    </select></div>
                <div class="col-sm-1 text-left height-34">Module</div>
                <div *ngIf="this.DisplayModule == '0'" class="col-sm-2"><select class="form-control"
                        formControlName="SelectModuleAlert" (change)="onSelectModuleAlert($event.target.value)">
                        <option value="3.1">Case</option>
                        <option value="3.2" selected>Decision</option>
                        <option value="3.3">Notice</option>
                    </select></div>
                <div *ngIf="this.DisplayModule == '1'" class="col-sm-2"><select class="form-control"
                        formControlName="SelectModuleEscalation"
                        (change)="onSelectModuleEscalation($event.target.value)">
                        <option value="4.1">Case</option>
                        <option value="4.2" selected>Decision</option>
                        <option value="4.3">Diary</option>
                        <option value="4.4">Notice</option>
                    </select></div>
                <div *ngIf="this.DisplayModule == '2'" class="col-sm-2"><select class="form-control"
                        formControlName="SelectModuleNotification"
                        (change)="onSelectModuleNotification($event.target.value)">
                        <option value="5.2">Case</option>
                        <option value="5.3" selected>Decision</option>
                        <option value="5.4">Notice</option>
                    </select></div>
                <div *ngIf="this.DisplayFeature > '2'" class="col-sm-1 text-left height-34">Feature</div>
                <div *ngIf="this.DisplayFeature == '3.1'" class="col-sm-2"><select class="form-control"
                        formControlName="SelectAlertDiary1" (change)="ForGetKeyword($event.target.value)">
                        <option value="M61">Diary</option>
                    </select></div>
                <div *ngIf="this.DisplayFeature == '3.2'" class="col-sm-2"><select class="form-control"
                        formControlName="SelectAlertDiary2" (change)="ForGetKeyword($event.target.value)">
                        <option value="M62">Diary</option>
                    </select></div>
                <div *ngIf="this.DisplayFeature == '3.3'" class="col-sm-2"><select class="form-control"
                        formControlName="SelectAlertDiary3" (change)="ForGetKeyword($event.target.value)">
                        <option value="M63">Diary</option>
                    </select></div>
                <div *ngIf="this.DisplayFeature == '4.1'" class="col-sm-2"><select class="form-control"
                        formControlName="SelectEscalationCase" (change)="ForGetKeyword($event.target.value)">
                        <option value="M71">Level 1</option>
                        <option value="M72">Level 2</option>
                        <option value="M73">Level 3</option>
                    </select></div>
                <div *ngIf="this.DisplayFeature == '4.2'" class="col-sm-2"><select class="form-control"
                        formControlName="SelectEscalationDecision" (change)="ForGetKeyword($event.target.value)">
                        <option value="M74">Level 1</option>
                        <option value="M75">Level 2</option>
                        <option value="M76">Level 3</option>
                    </select></div>
                <div *ngIf="this.DisplayFeature == '4.3'" class="col-sm-2"><select class="form-control"
                        formControlName="SelectEscalationDiary" (change)="ForGetKeyword($event.target.value)">
                        <option value="M77">Level 1</option>
                        <option value="M78">Level 2</option>
                        <option value="M79">Level 3</option>
                    </select></div>
                <div *ngIf="this.DisplayFeature == '4.4'" class="col-sm-2"><select class="form-control"
                        formControlName="SelectEscalationNotice" (change)="ForGetKeyword($event.target.value)">
                        <option value="M80">Level 1</option>
                        <option value="M81">Level 2</option>
                        <option value="M82">Level 3</option>
                    </select></div>
                <div *ngIf="this.DisplayFeature == '5.2'" class="col-sm-2"><select class="form-control"
                        formControlName="SelectNotificationCase" (change)="ForGetKeyword($event.target.value)">
                        <option value="M91">Assign</option>
                        <option value="M94">Follow UP</option>
                        <option value="M95">Diary</option>
                        <option value="M90">Diary Follow UP</option>
                    </select></div>
                <div *ngIf="this.DisplayFeature == '5.3'" class="col-sm-2"><select class="form-control"
                        formControlName="SelectNotificationDecision" (change)="ForGetKeyword($event.target.value)">
                        <option value="M92">Assign</option>
                        <option value="M96">Follow UP</option>
                        <option value="M97">Diary</option>
                        <option value="M88">Diary Follow UP</option>
                    </select></div>
                <div *ngIf="this.DisplayFeature == '5.4'" class="col-sm-2"><select class="form-control"
                        formControlName="SelectNotificationNotice" (change)="ForGetKeyword($event.target.value)">
                        <option value="M93">Assign</option>
                        <option value="M98">Follow UP</option>
                        <option value="M99">Diary</option>
                        <option value="M89">Diary Follow UP</option>
                    </select></div>
            </form>
        </div>

    </div>
</div>

<div class="col-sm-12" style="margin-top: 8px;">
    <div class=" col-sm-12 lefticonD paddingless"
        style="border-left:1px solid #ccc;border-top:1px solid #ccc; border-right:1px solid #ccc;">
        <label>Mail Template Editor </label>
    </div>

    <br>
    <form #emailEditor="ngForm" [formGroup]="FormemailEditor">
        <div class="col-sm-12" style="border:1px solid #ccc">
            <div class="container col-sm-8">
                <span><b>Subject</b></span><br>
                <angular-editor [(ngModel)]="textEditorData" formControlName="textEditorData"
                    [config]="config"></angular-editor>
                <br>
                <span><b>Mail Body</b></span><br>
                <angular-editor [(ngModel)]="textEditorData2" formControlName="textEditorData2"
                    [config]="config1"></angular-editor><br>
                <div class="col-sm-4">&nbsp;</div><input class="btn btn-primary btn-sm-8 " type="submit"
                    (click)="SaveData(emailEditor.value)" value="Submit"><br><br>
            </div>
            <div class="col-sm-4"> <br> &nbsp; &nbsp; &nbsp; &nbsp; <select class="form-control col-sm-8"
                    (change)="onStatusSelect($event.target.value)" formControlName="KeyWordRecord">
                    <option value="0">[Not Selected]</option>
                    <option *ngFor="let mDtl of KeywordData " value="{{mDtl.MainDescr}}">{{mDtl.MainDescr}}</option>
                </select><br>
            </div>
        </div>
    </form>
</div> -->

<!-- <div><br>&nbsp;</div> -->
<!-- <div class="form-group mt-2" style="display:none;">
            <div class="form-check">
                <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
                <label for="autoClose">Auto close alert after three seconds</label>
            </div>
    
        </div>
        <div class="jumbotron p-4">
            <div class="container text-center col-sm-3 alertCss">
                <app-alert></app-alert>
                <router-outlet></router-outlet>
            </div>
        </div> -->
<!-- </my-content> -->
<!-- <my-content placeholder="main">
    
    </my-content> -->
}